// Centralized brand/profile data — update freely.
export const profile = {
    brand: "Pranto.Gfx",
    founder: "Pranto",
    tagline:
        "Premium brand identity, logo systems, creative direction, and visual experiences.",
    description:
        "Pranto.Gfx is a premium branding and visual identity studio led by Pranto. We craft logo systems, identity systems, and creative direction for businesses that want to look more credible, more premium, and more unforgettable.",
    founderPhoto:
        "https://customer-assets.emergentagent.com/job_b090184f-8ffa-4acf-bd6b-d76aaaef9386/artifacts/lyw94g4s_asdasd.jpg",
    email: "Pranto.gfx22@gmail.com",
    socials: {
        whatsapp: "https://wa.me/message/EZRMO75WS7PMB1",
        instagram: "https://www.instagram.com/pranto.gfx/",
        behance: "https://be.net/shaikatpranto",
        linkedin: "#", // placeholder — update later
    },
    seo: {
        title:
            "Pranto.Gfx | Premium Logo Design, Branding And Creative Direction",
        description:
            "Pranto.Gfx creates premium logo systems, brand identities, creative direction, and digital visual experiences for businesses that want to look more professional, memorable, and high-value.",
    },
};

export default profile;
